import { DiashowItems } from "../types/diashow.type";

const diashowTranslationScope: string = "feature/auth";


export const DIASHOW_ITEMS: DiashowItems = [
  {
    image: "/public/images/diashow/ipanema-diashow.webp",
    alt: "Bild von Ipanema, Hamburg, Deutschland",
    url: "https://bcl-baulogistik.com/referenzen/detail/ref/ipanema-hamburg-deutschland/",
    translationInfoName: {
      defaultText: "Ipanema, Hamburg, Deutschland",
      token: "diashow-label-ipanema",
      scope: diashowTranslationScope
    },
    translationInfoDescription: {
      defaultText: "Auf dem Areal der ehemaligen Oberpostdirektion am Überseering 30 ist ein neues Geschäfts- und Wohnquartier entstanden, bestehend aus einem ovalförmigen Bürohaus (12 Etagen), einer Kita, Gastronomie sowie Nahversorgung und zwei geschwungenen Wohngebäuden mit insgesamt 523 Wohneinheiten, die sich jeweils in 18 Hauseingänge unterteilen. Unterirdisch ist das Gesamtensemble durch eine Tiefgarage verbunden.",
      token: "diashow-paragraph-ipanema",
      scope: diashowTranslationScope
    }
  },
  {
    image: "/public/images/diashow/one-forty-west-diashow.webp",
    alt: "Bild von ONE FORTY WEST (T-Rex), Frankfurt am Main, Deutschland",
    url: "https://bcl-baulogistik.com/referenzen/detail/ref/one-forty-west-t-rex-frankfurt-am-main-deutschland/",
    translationInfoName: {
      defaultText: "ONE FORTY WEST (T-Rex), Frankfurt am Main, Deutschland",
      token: "diashow-label-one-forty-west",
      scope: diashowTranslationScope
    },
    translationInfoDescription: {
      defaultText: "Bei dem Neubau «ONE FORTY WEST» handelt es sich um ein sogenanntes Hybridhochhaus mit einer Mischnutzung, das auf dem Gelände des ehemaligen AfE-Turms im Stadtteil Westend in Frankfurt am Main entstand.",
      token: "diashow-paragraph-one-forty-west",
      scope: diashowTranslationScope
    }
  },
  {
    image: "/public/images/diashow/sap-garden-diashow.webp",
    alt: "Bild von SAP Garden, München, Deutschland",
    url: "https://bcl-baulogistik.com/referenzen/detail/ref/sap-garden-muenchen-deutschland/",
    translationInfoName: {
      defaultText: "SAP Garden, München, Deutschland",
      token: "diashow-label-sap-garden",
      scope: diashowTranslationScope
    },
    translationInfoDescription: {
      defaultText: "Bei diesem komplexen Bauvorhaben handelt es sich um eine multifunktionale Sportarena mit einem Fassungsvermögen von bis zu 11.500 Zuschauerplätzen.",
      token: "diashow-paragraph-sap-garden",
      scope: diashowTranslationScope
    }
  },
  {
    image: "/public/images/diashow/kantonsspital-aarau-diashow.webp",
    alt: "Bild von Kantonsspital Aarau \"Dreiklang\" (KSA), Schweiz",
    url: "https://bcl-baulogistik.com/referenzen/detail/ref/neubau-kantonsspital-dreiklang-ksa-schweiz/",
    translationInfoName: {
      defaultText: "Kantonsspital Aarau \"Dreiklang\" (KSA), Schweiz",
      token: "diashow-label-cantonal-hospital",
      scope: diashowTranslationScope
    },
    translationInfoDescription: {
      defaultText: "In Aarau entsteht mit dem Kantonsspital der derzeit größte Krankenhausneubau der Schweiz. Die Bezeichnung \"Dreiklang\" erklärt sich aus dem optimalen Zusammenspiel zwischen den Funktionsbereichen und Ambulatorien im Sockelbau sowie dem darüberliegenden Bettenhaus.",
      token: "diashow-paragraph-cantonal-hospital",
      scope: diashowTranslationScope
    }
  }
];
